/** Человекочитаемый размер файла: `512 KB` / `4.2 MB` / `1.35 GB`. Используется в карточках
 *  документов (MediaWidgets), в инфопанели чата (ChatInfoModal) и в суммарном объёме медиа
 *  админ-панели (AdminPanel) — там значения могут доходить до ГБ, младшие ветки хватало для
 *  размера одного файла, но не для суммы по всему хранилищу. */
export function formatSize(bytes?: number): string {
  if (!bytes) return '';
  if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + ' KB';
  if (bytes < 1024 * 1024 * 1024) return (bytes / 1024 / 1024).toFixed(1) + ' MB';
  return (bytes / 1024 / 1024 / 1024).toFixed(2) + ' GB';
}
